import { render, staticRenderFns } from "./not-found.component.vue?vue&type=template&id=49cae1e1&scoped=true&"
import script from "./not-found.component.vue?vue&type=script&lang=ts&"
export * from "./not-found.component.vue?vue&type=script&lang=ts&"
import style0 from "./not-found.component.vue?vue&type=style&index=0&id=49cae1e1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cae1e1",
  null
  
)

export default component.exports